export default __webpack_public_path__ + "static/leestrathy-logo-white-8720200efb0ff76a16a4c59d0b5b31c3.svg";